/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _7 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>7 - Особенности графических форматов</h2>
    <p className={styles.description}>
      <b>Графический файл</b> — это описание цвета каждого пикселя в заданном прямоугольнике, этот прямоугольник также
      называют размером изображения. Например "изображение размера 800 на 600", где под единицей подразумевается
      пиксель.
    </p>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        <b>Растровая графика</b> — описание графического файла в виде массива с координатами каждого пикселя и описанием
        цвета этого пикселя. Основные представители это <code className={styles.code}>jpeg</code>,{' '}
        <code className={styles.code}>png</code>, <code className={styles.code}>webP</code>,{' '}
        <code className={styles.code}>gif</code>.
      </li>
      <li className={styles.list__item}>
        <b>Векторная графика</b> — описывается в виде правил или уравнений, определяющих линии. А также дополнительные
        свойства - цвет линий и фон для фигур, образующихся замкнутыми линиями. Это формат{' '}
        <code className={styles.code}>svg</code>.
      </li>
    </ul>
    <p className={styles.description}>
      Векторная графика будет отображаться одинаково хорошо на обычных экранах и на экранах с высокой пиксельной
      плотностью. Растровая графика, и особенно сжатая с потерей качества, будет выглядеть размыто.
    </p>
    <p className={styles.description}>
      <b>JPEG</b> — большие файлы не требующие прозрачного фона или анимации. Изображения JPEG идеальны для фотографий,
      они могут содержать миллионы различных цветов.
    </p>
    <p className={styles.description}>
      <b>PNG</b> — в отличие от JPEG имеет дополнительный параметр для описания прозрачности - альфа канал. Этот формат
      подходит для изображений сложной формы, не вписывающейся в прямоугольник. В таких случаях JPEG будет иметь белый
      фон, что не всегда совпадает с цветом фона подложки. Широко используется для иконок социальных сетей и графических
      элементов навигации.
    </p>
    <p className={styles.description}>
      <b>webP</b> — несмотря на поддержку из коробки только в Google Chrome, Opera и Android, стоит учесть, что речь
      идет о более 80% рынка браузеров. При равном качестве изображения сжатые файлы будут меньше PNG на 26%, для JPEG
      размер файла webP будет меньше на 25-34%. Добавление альфа канала "прибавит" только 22%. Такие компании как
      Google, Facebook и eBay используют этот формат для хранения изображений на своих серверах.
    </p>
    <p className={styles.description}>
      <b>SVG</b> — идеально подходит для простых масштабируемых изображений, занимая очень мало места. С ростом
      сложности изображения, когда для одного пикселя нужно отдельное описание, размер файла делает использование
      формата невыгодным. Как правило, этот формат используется для логотипа, иконок и элементов графической навигации.
    </p>
  </section>
))
